class User {
  constructor (data) {
    this.id = data ? data.id : ''
    this.name = data ? data.name : ''
    this.username = data ? data.username : ''
    this.organization = data ? data.organization : ''
    this.account = data ? data.account : ''
    this.password = ''
    this.role = data ? data.role : ''
    // eslint-disable-next-line eqeqeq
    this.is_enabled = data ? (data.is_enabled == 1) : false
    this.downloads = data ? data.downloads : -1
  }
}

export default User



// WEBPACK FOOTER //
// ./src/models/user.js